export default class HelperAnimation {
	
	static pulse = ( what ) => {
		if( what.current === undefined || what.current === null ) return;
		
		what.current.stopAnimation();
		what.current.bounceIn( 800 );
		
	}
	
	static fadeIn = ( what ) => {
		if( what.current === undefined || what.current === null ) return;
		
		what.current.stopAnimation();
		what.current.fadeIn(400);
	}
	
	static fadeOut = ( what ) => {
		if( what.current === undefined || what.current === null ) return;
		
		what.current.stopAnimation();
		what.current.fadeOut(400);
	}
	
}